import React from 'react';
import {
  Target,
  Trophy,
  FileText,
  MessageCircle,
  CheckCircle,
  XCircle,
  ArrowRight,
  ArrowLeft,
  Star,
  Heart,
  Flag,
  Tag,
  Bookmark,
  Bell,
  Calendar,
  Clock,
  DollarSign,
  TrendingUp,
  TrendingDown,
  BarChart3,
  PieChart,
  Users,
  User,
  Building,
  Briefcase,
  ShoppingCart,
  Package,
  Truck,
  CreditCard,
  Receipt,
  FileCheck,
  FileX,
  Folder,
  FolderOpen,
  Database,
  Server,
  Cloud,
  Zap,
  Rocket,
  Plane,
  Ship,
  Car,
  Bike,
  MapPin,
  Globe,
  Map,
  Compass,
  Navigation,
  Search,
  Filter,
  Settings,
  Cog,
  Wrench,
  Hammer,
  Key,
  Lock,
  Unlock,
  Shield,
  ShieldCheck,
  ShieldAlert,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Check,
  X,
  Plus,
  Minus,
  Edit,
  Trash2,
  Copy,
  Share,
  Download,
  Upload,
  Save,
  RefreshCw,
  RotateCw,
  Repeat,
  Play,
  Pause,
  SkipForward,
  SkipBack,
  FastForward,
  Rewind,
  Volume2,
  VolumeX,
  Mic,
  Video,
  Camera,
  Image,
  Film,
  Music,
  Headphones,
  Radio,
  Phone,
  PhoneCall,
  PhoneIncoming,
  PhoneOutgoing,
  PhoneMissed,
  Mail,
  Send,
  Inbox,
  Archive,
  Eye,
  EyeOff,
  Maximize,
  Minimize,
  Move,
  GripVertical,
  GripHorizontal,
  LayoutGrid,
  LayoutList,
  Columns,
  Rows,
  Grid,
  List,
  Menu,
  MoreVertical,
  MoreHorizontal,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Circle,
  Square,
  Triangle,
  Hexagon,
  Octagon,
  Diamond
} from 'lucide-react';

const PipelinePreview = ({ config }) => {
  const stages = (config.stages || []).filter(s => s.enabled !== false);
  const iconMap = {
    Target, Trophy, FileText, MessageCircle, CheckCircle, XCircle,
    ArrowRight, ArrowLeft, Star, Heart, Flag, Tag, Bookmark, Bell,
    Calendar, Clock, DollarSign, TrendingUp, TrendingDown, BarChart3,
    PieChart, Users, User, Building, Briefcase, ShoppingCart, Package,
    Truck, CreditCard, Receipt, FileCheck, FileX, Folder, FolderOpen,
    Database, Server, Cloud, Zap, Rocket,
    Plane, Ship, Car, Bike, MapPin, Globe, Map, Compass, Navigation,
    Search, Filter, Settings, Cog, Wrench, Hammer, Key, Lock,
    Unlock, Shield, ShieldCheck, ShieldAlert, AlertCircle, AlertTriangle,
    Info, HelpCircle, Check, X, Plus, Minus, Edit, Trash2, Copy, Share,
    Download, Upload, Save, RefreshCw, RotateCw, Repeat, Play, Pause,
    SkipForward, SkipBack, FastForward, Rewind, Volume2, VolumeX,
    Mic, Video, Camera, Image, Film, Music, Headphones, Radio, Phone,
    PhoneCall, PhoneIncoming, PhoneOutgoing, PhoneMissed, Mail, Send,
    Inbox, Archive, Eye, EyeOff, Maximize, Minimize, Move, GripVertical,
    GripHorizontal, LayoutGrid, LayoutList, Columns, Rows, Grid, List,
    Menu, MoreVertical, MoreHorizontal, ChevronDown, ChevronUp,
    ChevronLeft, ChevronRight, Circle, Square, Triangle, Hexagon,
    Octagon, Diamond
  };

  const getIconComponent = (iconName) => {
    return iconMap[iconName] || Target;
  };

  const getDefaultHeaderClass = (stageId) => {
    const defaults = {
      lead: 'from-indigo-500/90 to-indigo-400/80 text-white border-indigo-400/60 dark:from-indigo-700 dark:to-indigo-600 dark:text-slate-100 dark:border-indigo-700/60',
      opportunities: 'from-blue-500/90 to-blue-400/80 text-white border-blue-400/60 dark:from-blue-700 dark:to-blue-600 dark:text-slate-100 dark:border-blue-700/60',
      proposal: 'from-amber-500/90 to-amber-400/80 text-white border-amber-400/60 dark:from-amber-700 dark:to-amber-600 dark:text-slate-100 dark:border-amber-700/60',
      negotiate: 'from-orange-500/90 to-orange-400/80 text-white border-orange-400/60 dark:from-orange-700 dark:to-orange-600 dark:text-slate-100 dark:border-orange-700/60',
      won: 'from-emerald-500/90 to-emerald-400/80 text-white border-emerald-400/60 dark:from-emerald-700 dark:to-emerald-600 dark:text-slate-100 dark:border-emerald-700/60',
      lost: 'from-rose-500/90 to-rose-400/80 text-white border-rose-400/60 dark:from-rose-700 dark:to-rose-600 dark:text-slate-100 dark:border-rose-700/60'
    };
    return defaults[stageId] || 'from-slate-500/90 to-slate-400/80 text-white border-slate-400/60 dark:from-slate-700 dark:to-slate-600 dark:text-slate-100 dark:border-slate-700/60';
  };

  const getDefaultLaneBg = (stageId) => {
    const defaults = {
      lead: 'bg-gradient-to-b from-indigo-50/60 to-white dark:from-slate-800 dark:to-slate-900',
      opportunities: 'bg-gradient-to-b from-blue-50/60 to-white dark:from-slate-800 dark:to-slate-900',
      proposal: 'bg-gradient-to-b from-amber-50/60 to-white dark:from-slate-800 dark:to-slate-900',
      negotiate: 'bg-gradient-to-b from-orange-50/60 to-white dark:from-slate-800 dark:to-slate-900',
      won: 'bg-gradient-to-b from-emerald-50/60 to-white dark:from-slate-800 dark:to-slate-900',
      lost: 'bg-gradient-to-b from-rose-50/60 to-white dark:from-slate-800 dark:to-slate-900'
    };
    return defaults[stageId] || 'bg-gradient-to-b from-slate-50/60 to-white dark:from-slate-800 dark:to-slate-900';
  };

  if (stages.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-8 text-center">
        <p className="text-slate-500 dark:text-slate-400">
          No stages configured. Add stages in the "Stage Management" tab to see a preview.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
          Pipeline Preview
        </h2>
        <p className="text-sm text-slate-600 dark:text-slate-400">
          This is a preview of how your pipeline will appear. The actual pipeline will show leads and opportunities.
        </p>
      </div>

      <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
        <div className="flex gap-4 p-4 overflow-x-auto">
          {stages.map((stage) => {
            const Icon = getIconComponent(stage.icon);
            const headerClass = stage.headerClass || getDefaultHeaderClass(stage.id);
            const laneBg = stage.laneBg || getDefaultLaneBg(stage.id);

            return (
              <div
                key={stage.id}
                className={`flex-shrink-0 w-64 rounded-lg border ${laneBg} border-slate-200 dark:border-slate-700 shadow-sm`}
              >
                <div className={`rounded-t-lg border-b bg-gradient-to-r ${headerClass} px-4 py-3`}>
                  <div className="flex items-center gap-2">
                    <Icon className="h-4 w-4" />
                    <h3 className="text-sm font-semibold">{stage.displayName}</h3>
                  </div>
                </div>
                <div className="p-3 min-h-[200px]">
                  <div className="text-xs text-slate-500 dark:text-slate-400 text-center py-8">
                    No items in this stage
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Info className="h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-blue-800 dark:text-blue-300">
            <p className="font-medium mb-1">Preview Information:</p>
            <ul className="list-disc list-inside space-y-1 text-blue-700 dark:text-blue-400">
              <li>This preview shows the visual appearance of your pipeline stages</li>
              <li>Header colors and lane backgrounds are shown as configured</li>
              <li>Icons and display names are shown as configured</li>
              <li>The actual pipeline will display leads and opportunities based on stage mappings</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipelinePreview;

